type Pos = { x: number; y: number; next?: number };
type Move = {
  start: Pos;
  end: Pos;
  dir: "left" | "right" | "none" | "tornado";
};

const calculateMoves = (gen: any) => {
  const SHOW_LOGS = false;

  let startPositions: Pos[] = [];
  let endPositions: Pos[] = gen.transform.map((transform) => {
    return {
      x: transform.x,
      y: transform.y,
    };
  });

  gen.originalSymbols.forEach((reel, reelIdx) => {
    reel.forEach((symbol, rowIdx) => {
      if (symbol == "WI") {
        startPositions.push({
          x: reelIdx + 1,
          y: rowIdx + 1,
        });
      }
    });
  });

  let originalStart: Pos[] = JSON.parse(JSON.stringify(startPositions));
  let originalEnd: Pos[] = JSON.parse(JSON.stringify(endPositions));

  let moves: Move[] = [];
  let isTornado = false;

  while (endPositions.length > 0 && !isTornado) {
    SHOW_LOGS && console.log(endPositions.length);
    const endPos = endPositions.shift() as Pos;
    SHOW_LOGS && console.log(endPos);
    if (!endPos.next) endPos.next = 0;

    let hasLeft = startPositions.find(
      (sP) => sP.y == endPos.y && sP.x == endPos.x - 1
    );
    let hasRight = startPositions.find(
      (sP) => sP.y == endPos.y && sP.x == endPos.x + 1
    );
    let hasSame = startPositions.find(
      (sP) => sP.x == endPos.x && (sP.y == endPos.y || sP.y == endPos.y + 1)
    );

    SHOW_LOGS && console.log("Has left: " + hasLeft);
    SHOW_LOGS && console.log("Has right: " + hasRight);
    SHOW_LOGS && console.log("Has same: " + hasSame);

    let hasCount = 0;
    if (hasLeft) hasCount += 1;
    if (hasRight) hasCount += 1;
    if (hasSame) hasCount += 1;

    if (hasCount > 1) {
      // It has more than one option - maybe they are next to each other?
      let hasUnchecked = endPositions.find(
        (pos) => !pos || !pos.next || pos.next < 2
      );

      let hasNotSelf = 0;
      endPositions.forEach((posEnd) => {
        let posHasSelf = false;

        startPositions.forEach((posStart) => {
          if (
            posStart.x == posEnd.x &&
            (posStart.y == posEnd.y || posStart.y == posEnd.y + 1)
          ) {
            posHasSelf = true;
          }
        });

        if (!posHasSelf) {
          hasNotSelf += 1;
        }
      });

      SHOW_LOGS && console.log("unchecked: ", hasUnchecked);
      SHOW_LOGS && console.log("noSame: " + hasNotSelf);

      if (hasUnchecked) {
        // Has unchecked so not sure yet - move to the end of the array
        if (hasNotSelf == 0 && endPos.next > 0) {
          let positionsToLock = endPositions.concat();

          if (hasSame) {
            positionsToLock.push(endPos);
          } else {
            endPos.next += 1;
            endPositions.push(endPos);
          }

          SHOW_LOGS && console.log("pos: ");
          SHOW_LOGS && console.log("positionsToLock: ");
          SHOW_LOGS && console.log(positionsToLock);
          positionsToLock.forEach((pos) => {
            SHOW_LOGS && console.log(pos);
            // Has the same
            let same = startPositions.find(
              (sP) => sP.x == pos.x && (sP.y == pos.y || sP.y == pos.y + 1)
            );
            let left = startPositions.find(
              (sP) => sP.x == pos.x + 1 && sP.y == pos.y
            );
            let right = startPositions.find(
              (sP) => sP.x == pos.x - 1 && sP.y == pos.y
            );
            delete pos.next;
            moves.push({
              start: right
                ? { x: right.x, y: right.y }
                : left
                ? { x: left.x, y: left.y }
                : pos,
              end: pos,
              dir: right ? "right" : left ? "left" : "none",
            });
            if (right) {
              startPositions.splice(startPositions.indexOf(right), 1);
            } else if (left) {
              startPositions.splice(startPositions.indexOf(left), 1);
            } else if (same) {
              startPositions.splice(startPositions.indexOf(same), 1);
            }
            endPositions.splice(endPositions.indexOf(pos), 1);
          });
        } else {
          SHOW_LOGS && console.log("Not sure. Move on");
          endPos.next += 1;
          endPositions.push(endPos);
        }
      } else if (!hasNotSelf) {
        endPositions.forEach((pos) => {
          // Has the same
          let same = startPositions.find(
            (sP) => sP.x == pos.x && (sP.y == pos.y || sP.y == pos.y + 1)
          );
          delete pos.next;
          moves.push({
            start: pos,
            end: pos,
            dir: "none",
          });
          if (same) {
            startPositions.splice(startPositions.indexOf(same), 1);
          }
        });
        break;
      } else {
        // console.log("ERROR: SHOULD NOT HAPPEN");
        // return null;
        isTornado = true;
        break;
      }
    } else if (hasLeft) {
      // Found left
      delete endPos.next;
      moves.push({
        start: hasLeft,
        end: endPos,
        dir: "right",
      });
      // also remove the item as matched
      startPositions.splice(startPositions.indexOf(hasLeft), 1);
    } else if (hasRight) {
      // Found right
      delete endPos.next;
      moves.push({
        start: hasRight,
        end: endPos,
        dir: "left",
      });
      // also remove the item as matched
      startPositions.splice(startPositions.indexOf(hasRight), 1);
    } else if (hasSame) {
      // Found right
      delete endPos.next;
      moves.push({
        start: hasSame,
        end: endPos,
        dir: "none",
      });
      startPositions.splice(startPositions.indexOf(hasSame), 1);
    } else if (endPos.next == 2 && hasSame) {
      // Has the same
      delete endPos.next;
      moves.push({
        start: hasSame,
        end: endPos,
        dir: "none",
      });
      startPositions.splice(startPositions.indexOf(hasSame), 1);
    } else if (endPos.next == 2) {
      // If there is no possible action - this is the Tornado feature
      isTornado = true;
    } else {
      // Move on
      endPos.next += 1;
      endPositions.push(endPos);
    }
  }

  if (isTornado) {
    moves = [];

    originalStart.forEach((startPos, idx) => {
      moves.push({
        start: startPos,
        end: originalEnd[idx],
        dir: "tornado",
      });
    });
  }

  removeOverlaps(moves);

  return moves;
};

const removeOverlaps = (moves: Move[]) => {
  for (const move of moves) {
    // Makes sense only of moving wilds
    if (move.dir === "left" || move.dir === "right") {
      const overlapped = moves.find(
        // Check if there's another move that is exactly the opposite of this one
        (m) => samePos(move.start, m.end) && samePos(move.end, m.start)
      );

      // If there is an opposite - clear both moves
      if (overlapped) {
        // This one
        move.dir = "none";
        move.start = { x: move.end.x, y: move.end.y };

        // The opposite one
        overlapped.dir = "none";
        overlapped.start = { x: move.end.x, y: move.end.y };
      }
    }
  }

  return moves;
};

const samePos = (first: Pos, second: Pos) => {
  return first.x === second.x && first.y === second.y;
};

const BBWildsMovements = {
  calculateMoves
};

export default BBWildsMovements
